import {useMediaQuery, useTheme} from "@mui/material";

export function useScreenSize() {
	const theme = useTheme()
	const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('xs'))
	const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
	const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'))
	const isLargeScreen = useMediaQuery(theme.breakpoints.down('lg'))

	const currentScreenSize = isExtraSmallScreen ? 'xs' : isSmallScreen ? 'sm' : isMediumScreen ? 'md' : isLargeScreen ? 'lg' : 'xl'

	function getScreenValue<T>({xs, sm, md, lg, xl}: { xs?: T, sm?: T, md?: T, lg?: T, xl?: T }) {
		const res = ({
			xs: xs ?? sm ?? md ?? lg ?? xl,
			sm: sm ?? xs ?? lg ?? xl ?? sm,
			md: md ?? sm ?? lg ?? xl ?? md,
			lg: lg ?? md ?? sm ?? xl ?? lg,
			xl: xl ?? lg ?? md ?? sm ?? xl
		})

		return res[currentScreenSize] as T
	}

	const isMobile = getScreenValue({xs: true, sm: true, md: true, lg: false, xl: false})

	return {currentScreenSize, getScreenValue, isMobile}
}